import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import BillboardEdit        from "./BillboardEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Filter               from "Dashboard/Components/Filter/Filter";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Billboard List
 * @returns {React.ReactElement}
 */
function BillboardList() {
    const { fetch, load, loadFilter } = useList("billboard");

    const data = Store.useState("billboard");
    const { loading, canEdit, list, total, filters, sort } = data;

    const { deleteElem } = Store.useAction("billboard");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "billboardID", elemID, "title");

    return <Main>
        <Header message="BILLBOARDS_NAME" icon="billboard">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Filter
                onFilter={loadFilter}
                values={filters}
                hasSearch
            />
            <Table
                fetch={load}
                sort={sort}
                none="BILLBOARDS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="publishTime" message="GENERAL_DATE"        maxWidth="100" />
                    <TableHeader field="title"       message="GENERAL_TITLE"       isTitle />
                    <TableHeader field="showBefore"  message="ENTRIES_SHOW_BEFORE" align="center" maxWidth="110" />
                    <TableHeader field="status"      message="GENERAL_STATUS"      align="center" maxWidth="100" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.billboardID} elemID={elem.billboardID}>
                        <TableCell message={elem.publishTimeDate} />
                        <TableCell message={elem.title}           />
                        <TableCell message={elem.showBeforeText}  />
                        <TableCell message={elem.statusName}      textColor={elem.statusColor} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="BILLBOARDS_EDIT_TITLE"   />
                    <TableAction action="COPY"   message="BILLBOARDS_COPY_TITLE"   />
                    <TableAction action="DELETE" message="BILLBOARDS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <BillboardEdit
            open={action.isVCCE}
            isCopy={action.isCopy}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="BILLBOARDS_DELETE_TITLE"
            message="BILLBOARDS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default BillboardList;
